module.exports = __webpack_public_path__ + "c216ade077885f00cccc90279a3132f4.png";